<template>
  <div class="table-settings">
    <h1 class="settings-title">
      Contacts
    </h1>
    <h2 class="settings-subtitle">
      Contact Fields
    </h2>
    <button
      class="btn btn-main btn-round mb-3"
      @click="openCustomFieldModal()">Create New Field</button>

    <b-table
      :fields="customFieldFields"
      :items="contactFields"
      show-empty
      responsive
      class="merchant-dashboard__table scroll-area-horizontal">
      <!-- Name column -->
      <template v-slot:cell(name)="data">
        {{ data.item.name }}
      </template>

      <!-- Type column -->
      <template v-slot:cell(type)="data">
        {{ getFieldTypeName(data.item.type) }}
      </template>

      <!-- Actions column -->
      <template v-slot:cell(actions)="data">
        <b-dropdown
          :disabled="data.item.static"
          right
          no-flip
          no-caret
          class="actions">
          <!-- button -->
          <template v-slot:button-content>
            <icon name="ellipsis-h"/>
          </template>
          <!-- Items -->
          <b-dropdown-item @click="openCustomFieldModal(data.item)">
            Edit
          </b-dropdown-item>
          <b-dropdown-item @click="openDeleteCustomFieldModal(data.item)">
            Delete
          </b-dropdown-item>
        </b-dropdown>
      </template>

      <!-- No data content -->
      <template v-slot:empty="">
        <div
          v-if="!customFieldList.length && !loadingCustomFields"
          slot="empty"
          class="no-data text-center">
          <span class="d-block my-4">
            No custom fields found.
          </span>
        </div>
        <div
          v-if="!customFieldList.length && loadingCustomFields"
          slot="empty"
          class="loader">
          <div class="loading-circle"/>
        </div>
      </template>
    </b-table>

    <h2 class="settings-subtitle mt-5">
      Tags
    </h2>
    <button
      class="btn btn-main btn-round mb-3"
      @click="openContactTagModal()">Create New Tag</button>
    <b-table
      :fields="tagFields"
      :items="contactTagList"
      show-empty
      responsive
      class="merchant-dashboard__table scroll-area-horizontal">

      <!-- Name column -->
      <template v-slot:cell(name)="data">
        {{ data.item.name }}
      </template>

      <!-- Actions column -->
      <template v-slot:cell(actions)="data">
        <b-dropdown
          right
          no-flip
          no-caret
          class="actions">
          <!-- button -->
          <template v-slot:button-content>
            <icon name="ellipsis-h"/>
          </template>
          <!-- Items -->
          <b-dropdown-item @click="openContactTagModal(data.item)">
            Edit
          </b-dropdown-item>
          <b-dropdown-item @click="openDeleteContactTagModal(data.item)">
            Delete
          </b-dropdown-item>
        </b-dropdown>
      </template>

      <!-- No data content -->
      <template v-slot:empty="">
        <div
          v-if="!contactTagList.length && !loadingContactTags"
          class="no-data text-center">
          <span class="d-block my-4">
            No tags found.
          </span>
        </div>
        <div
          v-if="!contactTagList.length && loadingContactTags"
          class="loader">
          <div class="loading-circle"/>
        </div>
      </template>
    </b-table>

    <CustomFieldModal
      ref="customFieldModal"
      :fieldp="selectedField"
      @saved="fetchCustomFields({
        organisationId: $route.params.organisationId,
        businessId: $route.params.merchant_id,
      })"/>
    <CustomFieldDeleteModal
      ref="customFieldDeleteModal"
      :fieldp="selectedField"
      @deleted="fetchCustomFields({
        organisationId: $route.params.organisationId,
        businessId: $route.params.merchant_id,
      })"/>
    <ContactTagModal
      ref="contactTagModal"
      :tagp="selectedTag"
      @saved="fetchContactTags({
        merchantId: $route.params.merchant_id,
      })"/>
    <ContactTagDeleteModal
      ref="contactTagDeleteModal"
      :tagp="selectedTag"
      @deleted="fetchContactTags({
        merchantId: $route.params.merchant_id,
      })"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import fieldTypes from '@/helpers/lists/fieldTypes';
import contactStaticFields from '@/helpers/lists/contactStaticFields';
import CustomFieldModal from './modals/CustomFieldModal';
import ContactTagModal from './modals/ContactTagModal';
import CustomFieldDeleteModal from './modals/CustomFieldDeleteModal';
import ContactTagDeleteModal from './modals/ContactTagDeleteModal';
// import ChangeMemberRoleModal from './modals/ChangeMemberRoleModal';
// import MemberDeleteModal from './modals/MemberDeleteModal';

export default {
  name: 'ContactSettings',
  components: {
    CustomFieldModal,
    CustomFieldDeleteModal,
    ContactTagModal,
    ContactTagDeleteModal,
  },
  data() {
    return {
      fieldTypes,
      contactStaticFields,
      customFieldFields: [
        'name',
        'type',
        {
          key: 'actions',
          class: 'text-right',
        },
      ],
      tagFields: [
        {
          key: 'name',
          class: 'text-capitalize',
        },
        {
          key: 'actions',
          class: 'text-right',
        },
      ],
      selectedField: {},
      selectedTag: {},
    };
  },
  computed: {
    ...mapGetters({
      customFieldList: 'contact/customFieldList',
      contactTagList: 'contact/contactTagList',
      loadingCustomFields: 'contact/loadingCustomFields',
      loadingContactTags: 'contact/loadingContactTags',
      apiError: 'contact/apiError',
    }),
    contactFields() {
      return this.$lodash.concat(this.contactStaticFields, this.customFieldList);
    },
  },
  mounted() {
    // this.fetchCustomFields({
    //   organisationId: this.$route.params.organisationId,
    // });
    this.fetchContactTags({
      merchantId: this.$route.params.merchant_id,
    });
  },
  methods: {
    // TODO refactor updates
    ...mapActions({
      fetchCustomFields: 'contact/fetchCustomFields20',
      fetchContactTags: 'contact/fetchContactTags',
    }),
    getFieldTypeName(type) {
      const fieldType = this.$lodash.find(this.fieldTypes, fieldType => fieldType.alias === type);

      return fieldType ? fieldType.name : type;
    },
    openCustomFieldModal(field = null) {
      this.selectedField = field || {};
      this.$nextTick(() => {
        this.$refs.customFieldModal.show();
      });
    },
    openDeleteCustomFieldModal(field) {
      this.selectedField = field;
      this.$nextTick(() => {
        this.$refs.customFieldDeleteModal.show();
      });
    },
    openContactTagModal(tag = null) {
      this.selectedTag = tag || {};
      this.$nextTick(() => {
        this.$refs.contactTagModal.show();
      });
    },
    openDeleteContactTagModal(tag) {
      this.selectedTag = tag;
      this.$nextTick(() => {
        this.$refs.contactTagDeleteModal.show();
      });
    },
  },
};
</script>
